import { render, staticRenderFns } from "./ManageQuestionForm.vue?vue&type=template&id=1f2b0a60&"
import script from "./ManageQuestionForm.vue?vue&type=script&lang=js&"
export * from "./ManageQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports